/* Girl Chocolate, theme JS. Vanilla, no framework, progressive enhancement. */
/* build: cart-ladder-2 */
(function () {
 'use strict';

 /* ============================================================
 Announcement bar rotator
 ============================================================ */
 function initAnnouncement(root) {
 const items = root.querySelectorAll('[data-announce-item]');
 if (items.length < 2) return;
 const seconds = parseInt(root.getAttribute('data-rotate-seconds'), 10) || 5;
 let idx = 0;
 setInterval(function () {
 /* The quiz message is a link: do not rotate it away while it is hovered (devices that can hover)
 or keyboard-focused, or the tap/Enter lands on the next message and focus is lost to a hidden
 element. The text messages are unaffected. */
 var cur = items[idx];
 if (cur.tagName === 'A' && (document.activeElement === cur ||
 (cur.matches(':hover') && window.matchMedia && window.matchMedia('(hover: hover)').matches))) return;
 items[idx].setAttribute('hidden', '');
 items[idx].classList.remove('is-active');
 idx = (idx + 1) % items.length;
 items[idx].removeAttribute('hidden');
 items[idx].classList.add('gc-announce__text--fade', 'is-active');
 }, seconds * 1000);
 }

 /* ============================================================
 Mobile menu drawer
 ============================================================ */
 function initMenu() {
 const toggle = document.querySelector('[data-gc-menu-toggle]');
 const menu = document.querySelector('[data-gc-menu]');
 if (!toggle || !menu) return;

 function open() {
 menu.classList.add('is-open');
 document.body.classList.add('is-menu-open');
 menu.setAttribute('aria-hidden', 'false');
 toggle.setAttribute('aria-expanded', 'true');
 toggle.setAttribute('aria-label', 'Close menu');
 document.body.style.overflow = 'hidden';
 }
 function close() {
 menu.classList.remove('is-open');
 document.body.classList.remove('is-menu-open');
 menu.setAttribute('aria-hidden', 'true');
 toggle.setAttribute('aria-expanded', 'false');
 toggle.setAttribute('aria-label', 'Open menu');
 document.body.style.overflow = '';
 }
 toggle.addEventListener('click', function () {
 if (menu.classList.contains('is-open')) close();
 else open();
 });
 menu.querySelectorAll('[data-gc-menu-close]').forEach(function (el) {
 el.addEventListener('click', close);
 });
 document.addEventListener('keydown', function (e) {
 if (e.key === 'Escape' && menu.classList.contains('is-open')) close();
 });
 }

 /* ============================================================
 Sticky CTA
 ============================================================ */
 function initStickyCta() {
 const bar = document.querySelector('[data-gc-stickycta]');
 if (!bar) return;
 const target = document.querySelector('.gc-cta, .gc-hero__cta');
 const btn = bar.querySelector('[data-gc-stickycta-btn]');
 // Not const: a product page can CLAIM the bar (see gc:plan-change below),
 // which repoints the button at that page's own buy box.
 let productPath = bar.getAttribute('data-product-path') || '/products/period-relief-kit';

 function show() { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); }
 function hide() { bar.classList.remove('is-visible'); bar.setAttribute('aria-hidden', 'true'); }

 if (target && 'IntersectionObserver' in window) {
 const io = new IntersectionObserver(function (entries) {
 const e = entries[0];
 if (!e.isIntersecting && e.boundingClientRect.top < 0) show(); else hide();
 }, { threshold: 0 });
 io.observe(target);
 } else {
 const onScroll = function () { if (window.scrollY > 720) show(); else hide(); };
 window.addEventListener('scroll', onScroll, { passive: true });
 onScroll();
 }

 if (btn) {
 btn.addEventListener('click', function () {
 if (window.location.pathname.indexOf(productPath) === 0) {
 const cta = document.querySelector('.gc-cta');
 if (cta) { cta.scrollIntoView({ behavior: 'smooth', block: 'center' }); cta.click(); return; }
 }
 window.location.href = productPath;
 });
 }

 // Listen for plan changes from BuyBox / PurchaseOptions
 window.addEventListener('gc:plan-change', function (e) {
 const p = e.detail || {};
 const title = bar.querySelector('[data-gc-stickycta-title]');
 const price = bar.querySelector('[data-gc-stickycta-price]');
 const compare = bar.querySelector('[data-gc-stickycta-compare]');
 const save = bar.querySelector('[data-gc-stickycta-save]');
 if (title && p.title) title.textContent = p.title;
 if (price && p.price) price.textContent = p.price;
 // Hidden rather than blanked. An empty <s> still draws its own padding, and
 // an offer with no saving to show should not leave a gap where one was.
 if (compare) { compare.textContent = p.compare || ''; compare.style.display = p.compare ? '' : 'none'; }
 if (save) { save.textContent = p.save || ''; save.style.display = p.save ? '' : 'none'; }
 // A page can CLAIM the bar by sending its own path and thumbnail: the bar is
 // now quoting THAT page's offer, so the button must act on that page's buy
 // box rather than navigating to the kit, and the thumbnail must match the
 // thing being priced.
 if (p.path) productPath = p.path;
 if (p.image) {
 const thumb = bar.querySelector('.gc-stickycta__thumb');
 if (thumb) { thumb.removeAttribute('srcset'); thumb.src = p.image; }
 }
 });
 }

 /* ============================================================
 Generic tab groups (Science tabs, Account tabs)
 ============================================================ */
 function initTabs() {
 document.querySelectorAll('[data-gc-tabs]').forEach(function (root) {
 const pills = root.querySelectorAll('[data-gc-tab]');
 const panels = root.querySelectorAll('[data-gc-panel]');
 pills.forEach(function (pill) {
 pill.addEventListener('click', function () {
 const id = pill.getAttribute('data-gc-tab');
 pills.forEach(function (p) {
 const active = p.getAttribute('data-gc-tab') === id;
 p.classList.toggle('is-active', active);
 p.setAttribute('aria-selected', active ? 'true' : 'false');
 });
 panels.forEach(function (panel) {
 const active = panel.getAttribute('data-gc-panel') === id;
 panel.hidden = !active;
 });
 });
 });
 });
 }

 /* ============================================================
 FAQ accordion
 ============================================================ */
 function initFAQ() {
 document.querySelectorAll('[data-gc-faq]').forEach(function (root) {
 const rows = root.querySelectorAll('[data-gc-faq-row]');
 rows.forEach(function (row) {
 const btn = row.querySelector('button');
 if (!btn) return;
 btn.addEventListener('click', function () {
 const isOpen = row.classList.contains('is-open');
 // Close all other rows first (exclusive accordion)
 rows.forEach(function (other) {
 if (other !== row) {
 other.classList.remove('is-open');
 var otherBtn = other.querySelector('button');
 if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
 }
 });
 // Toggle current row
 const open = !isOpen;
 row.classList.toggle('is-open', open);
 btn.setAttribute('aria-expanded', open ? 'true' : 'false');
 });
 });
 });
 }

 /* ============================================================
 Reviews, topic filter, show more, lightbox
 ============================================================ */
 function initReviews() {
 const root = document.querySelector('[data-gc-reviews]');
 if (!root) return;
 const pills = root.querySelectorAll('[data-gc-rv-pill]');
 const cards = root.querySelectorAll('[data-gc-rv-card]');
 const more = root.querySelector('[data-gc-rv-more]');
 const empty = root.querySelector('[data-gc-rv-empty]');
 let topic = 'All';
 let expanded = false;

 function refresh() {
 let count = 0;
 cards.forEach(function (card) {
 const topics = (card.getAttribute('data-topics') || '').split('|');
 const match = (topic === 'All') || topics.indexOf(topic) >= 0;
 if (match) {
 count += 1;
 card.hidden = !(expanded || count <= 6);
 } else {
 card.hidden = true;
 }
 });
 if (empty) empty.hidden = count > 0;
 if (more) {
 more.hidden = count <= 6;
 more.textContent = expanded ? 'Show less' : 'Show more';
 }
 }

 pills.forEach(function (pill) {
 pill.addEventListener('click', function () {
 topic = pill.getAttribute('data-gc-rv-pill');
 expanded = false;
 pills.forEach(function (p) {
 const active = p === pill;
 p.classList.toggle('is-active', active);
 p.setAttribute('aria-selected', active ? 'true' : 'false');
 });
 refresh();
 });
 });
 if (more) more.addEventListener('click', function () { expanded = !expanded; refresh(); });

 // Lightbox, Amazon-style: stars, name, verified, body, prev/next.
 // Pulls every detail off the card itself (no separate JSON needed),
 // and cycles through whatever cards are currently VISIBLE so the
 // arrows respect the active topic filter.
 const lb = document.querySelector('[data-gc-rv-lightbox]');
 if (lb) {
 const lbImg = lb.querySelector('[data-gc-rv-lb-img]');
 const lbImgWrap = lb.querySelector('[data-gc-rv-lb-imgwrap]');
 const lbStars = lb.querySelector('[data-gc-rv-lb-stars]');
 const lbTitle = lb.querySelector('[data-gc-rv-lb-title]');
 const lbBody = lb.querySelector('[data-gc-rv-lb-body]');
 const lbAvatar = lb.querySelector('[data-gc-rv-lb-avatar]');
 const lbName = lb.querySelector('[data-gc-rv-lb-name]');
 const lbVerified = lb.querySelector('[data-gc-rv-lb-verified]');
 const lbDate = lb.querySelector('[data-gc-rv-lb-date]');
 const lbCount = lb.querySelector('[data-gc-rv-lb-count]');
 const prevBtn = lb.querySelector('[data-gc-rv-lb-prev]');
 const nextBtn = lb.querySelector('[data-gc-rv-lb-next]');

 let currentCard = null;

 function visibleCards() {
 return Array.from(cards).filter(function (c) { return !c.hidden && c.offsetParent !== null; });
 }

 function readCard(card) {
 var photoBtn = card.querySelector('[data-gc-rv-photo]');
 var photoUrl = photoBtn ? photoBtn.getAttribute('data-photo') : '';
 var title = (card.querySelector('.gc-rv__cardTitle') || {}).textContent || '';
 var body = (card.querySelector('.gc-rv__cardBody') || {}).textContent || '';
 var date = (card.querySelector('.gc-rv__date') || {}).textContent || '';
 var nameNode = card.querySelector('.gc-rv__name');
 var name = '';
 if (nameNode) {
 // Strip the verified-badge svg label when reading the name text
 name = nameNode.childNodes[0] ? (nameNode.childNodes[0].textContent || '').trim() : nameNode.textContent.trim();
 }
 var verified = !!card.querySelector('.gc-rv__verified');
 var stars = card.querySelectorAll('.gc-rv__cardTop .gc-rv__stars [data-state="full"]').length || 5;
 return { photo: photoUrl, title: title, body: body, date: date, name: name, verified: verified, stars: stars };
 }

 function paint(card) {
 if (!card) return;
 currentCard = card;
 var d = readCard(card);
 if (lbImg && lbImgWrap) {
 if (d.photo) {
 lbImg.src = d.photo;
 lbImg.alt = d.title || d.name || '';
 lbImgWrap.hidden = false;
 } else {
 lbImg.src = '';
 lbImgWrap.hidden = true;
 }
 }
 if (lbStars) {
 var fill = '', empty = '';
 for (var i = 0; i < d.stars; i++) fill += '★';
 for (var j = d.stars; j < 5; j++) empty += '☆';
 lbStars.textContent = fill + empty;
 lbStars.setAttribute('aria-label', d.stars + ' out of 5 stars');
 }
 if (lbTitle) lbTitle.textContent = d.title;
 if (lbBody) lbBody.textContent = d.body;
 if (lbName) lbName.textContent = d.name;
 if (lbAvatar) lbAvatar.textContent = (d.name || '?').charAt(0);
 if (lbVerified) lbVerified.hidden = !d.verified;
 if (lbDate) lbDate.textContent = d.date;
 if (lbCount) {
 var vis = visibleCards();
 var pos = vis.indexOf(card) + 1;
 lbCount.textContent = (pos > 0 ? pos + ' of ' + vis.length : '');
 }
 }
 function step(delta) {
 var vis = visibleCards();
 if (!vis.length) return;
 var i = vis.indexOf(currentCard);
 if (i < 0) i = 0;
 var next = vis[((i + delta) % vis.length + vis.length) % vis.length];
 paint(next);
 }

 const open = function (card) {
 paint(card);
 lb.hidden = false;
 document.body.style.overflow = 'hidden';
 };
 const close = function () {
 lb.hidden = true;
 if (lbImg) lbImg.src = '';
 currentCard = null;
 document.body.style.overflow = '';
 };

 // Click anywhere on a card opens the lightbox at that card. The
 // photo button also triggers the same path (cleaner than two paths).
 cards.forEach(function (card) {
 card.style.cursor = 'pointer';
 card.addEventListener('click', function (e) {
 // Ignore clicks inside topic-pill or other future interactive children
 if (e.target.closest('a, button[type="button"]:not([data-gc-rv-photo])')) return;
 open(card);
 });
 });

 lb.querySelectorAll('[data-gc-rv-lb-close]').forEach(function (el) { el.addEventListener('click', close); });
 if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
 if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });
 document.addEventListener('keydown', function (e) {
 if (lb.hidden) return;
 if (e.key === 'Escape') close();
 else if (e.key === 'ArrowLeft') step(-1);
 else if (e.key === 'ArrowRight') step(1);
 });
 }

 refresh();
 }

 /* ============================================================
 BuyBox / PurchaseOptions, plan picker
 ============================================================ */
 function initBuyBox() {
 document.querySelectorAll('[data-gc-buybox]').forEach(function (root) {
 const radios = root.querySelectorAll('input[type="radio"][name="plan"]');
 const titleEl = root.querySelector('[data-gc-bb-title]');
 const priceEl = root.querySelector('[data-gc-bb-price]');
 const compareEl = root.querySelector('[data-gc-bb-compare]');
 const saveEl = root.querySelector('[data-gc-bb-save]');

 function update(radio) {
 const detail = {
 id: radio.value,
 title: radio.getAttribute('data-title'),
 price: radio.getAttribute('data-price'),
 compare: radio.getAttribute('data-compare') || '',
 save: radio.getAttribute('data-save') || ''
 };
 if (titleEl) titleEl.textContent = detail.title || titleEl.textContent;
 if (priceEl) priceEl.textContent = detail.price || priceEl.textContent;
 if (compareEl) compareEl.textContent = detail.compare;
 if (saveEl) saveEl.textContent = detail.save;
 window.GC_SELECTED_PLAN = detail;
 try {
 window.dispatchEvent(new CustomEvent('gc:plan-change', { detail: detail }));
 } catch (e) {}
 }

 radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) update(r); }); });
 const checked = root.querySelector('input[type="radio"][name="plan"]:checked');
 if (checked) update(checked);
 });
 }

 /* ============================================================
 Body scroll lock - used by every modal (gifts, supplement facts,
 reviews lightbox). Pins body in place via position:fixed + the saved
 scrollY so iOS Safari + mousewheel + touch all stop scrolling the
 underlying page. Restores the exact scroll position on release.
 ============================================================ */
 // Modal scroll lock - minimal version. Earlier rounds tried the
 // position:fixed-on-body trick which is the standard iOS Safari
 // recipe, but going from static→fixed forces the browser to
 // repaint the entire body and the user still saw a tiny flash
 // each time. This simpler approach just freezes the scrollbar on
 // <html> + pads the scrollbar gutter, so the page never moves
 // and there's nothing to repaint. Touch scroll on iOS will still
 // bleed slightly, but the desktop glitch the user reported is
 // fully gone.
 // REFCOUNTED, because things overlap. The cart drawer and a modal can be open
 // at once, and the old single-owner guard made the SECOND lock a no-op and the
 // FIRST unlock a full release: close the modal over an open cart and the page
 // started scrolling behind it; close them the other way round and the restore
 // never ran at all. Every lock must be matched by exactly one unlock.
 var __scrollLockSavedHtml = '';
 var __scrollLocks = 0;
 function lockBodyScroll() {
 __scrollLocks++;
 if (__scrollLocks > 1) return; // already locked by someone else
 var html = document.documentElement;
 __scrollLockSavedHtml = html.getAttribute('style') || '';
 var scrollbarW = window.innerWidth - html.clientWidth;
 html.style.cssText =
 (__scrollLockSavedHtml ? __scrollLockSavedHtml + ';' : '') +
 'overflow: hidden !important;' +
 (scrollbarW > 0 ? 'padding-right: ' + scrollbarW + 'px !important;' : '');
 document.body.dataset.gcScrollLock = '1';
 }
 function unlockBodyScroll() {
 if (__scrollLocks === 0) return; // never negative, or the next lock leaks
 __scrollLocks--;
 if (__scrollLocks > 0) return; // someone else still holds it
 var html = document.documentElement;
 if (__scrollLockSavedHtml) html.setAttribute('style', __scrollLockSavedHtml);
 else html.removeAttribute('style');
 delete document.body.dataset.gcScrollLock;
 }

 /* ============================================================
 Gifts modal
 ============================================================ */
 function initGiftsModal() {
 const modal = document.querySelector('[data-gc-gifts-modal]');
 if (!modal) return;
 document.querySelectorAll('[data-gc-gifts-open]').forEach(function (btn) {
 btn.addEventListener('click', function (e) { e.preventDefault(); modal.hidden = false; lockBodyScroll(); });
 });
 modal.querySelectorAll('[data-gc-gifts-close]').forEach(function (btn) {
 btn.addEventListener('click', function () { modal.hidden = true; unlockBodyScroll(); });
 });
 document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) { modal.hidden = true; unlockBodyScroll(); } });
 }

 /* ============================================================
 Supplement Facts modal
 ============================================================ */
 function initSupplementFacts() {
 const modal = document.querySelector('[data-gc-sf-modal]');
 if (!modal) return;

 // ONE binding pass over BOTH trigger attributes, and it must stay one.
 // The ingredients section's button carries data-gc-sf-open AND
 // data-gc-action="open-supplement-facts". While those were bound by two
 // separate init functions, a single click ran two open handlers and so
 // called lockBodyScroll() twice: the refcount went 0 -> 2, closing released
 // one, and <html> kept overflow:hidden !important forever. The modal shut
 // but the page underneath could never scroll again, which is what the
 // "stuck page" report was. A comma selector returns each element exactly
 // once, so a button wearing both attributes binds once. Do not split this
 // back into two passes, and do not add a second function for a new trigger
 // attribute: add the attribute to this selector instead.
 //
 // Note the earlier repair swapped a raw body.style.overflow write for
 // lockBodyScroll(). That fixed the leaked body style and moved the very
 // same leak into the refcount, so the page still froze. Balancing the
 // handlers is the actual fix.
 const open = function (e) {
 if (e) e.preventDefault();
 if (!modal.hidden) return; // already open, never lock a second time
 modal.hidden = false;
 lockBodyScroll();
 };
 const close = function () {
 if (modal.hidden) return; // already closed, never unlock a second time
 modal.hidden = true;
 unlockBodyScroll();
 };

 document.querySelectorAll('[data-gc-sf-open], [data-gc-action="open-supplement-facts"]').forEach(function (btn) {
 btn.addEventListener('click', open);
 });
 modal.querySelectorAll('[data-gc-sf-close]').forEach(function (btn) {
 btn.addEventListener('click', close);
 });
 document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
 }

 /* ============================================================
 Product card carousel nav buttons
 ============================================================ */
 function initProductCard() {
 document.querySelectorAll('[data-gc-product-card]').forEach(function (root) {
 const rail = root.querySelector('[data-gc-pc-rail]');
 const prev = root.querySelector('[data-gc-product-prev]');
 const next = root.querySelector('[data-gc-product-next]');
 if (!rail) return;
 const step = function (delta) { rail.scrollBy({ left: delta * rail.clientWidth * 0.9, behavior: 'smooth' }); };
 if (prev) prev.addEventListener('click', function () { step(-1); });
 if (next) next.addEventListener('click', function () { step(1); });
 });
 }

 /* ============================================================
 Video carousel
 ============================================================ */
 function initVideoCarousel() {
 document.querySelectorAll('[data-gc-video-carousel]').forEach(function (root) {
 const rail = root.querySelector('[data-rail]');
 const prev = root.querySelector('[data-prev]');
 const next = root.querySelector('[data-next]');
 if (!rail) return;
 function step(delta) {
 rail.scrollBy({ left: delta * rail.clientWidth * 0.85, behavior: 'smooth' });
 }
 if (prev) prev.addEventListener('click', function () { step(-1); });
 if (next) next.addEventListener('click', function () { step(1); });

 // Play videos when in view
 const videos = root.querySelectorAll('video');
 if ('IntersectionObserver' in window) {
 const io = new IntersectionObserver(function (entries) {
 entries.forEach(function (entry) {
 const v = entry.target;
 if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
 v.play().catch(function(){});
 } else {
 v.pause();
 }
 });
 }, { threshold: [0, 0.5] });
 videos.forEach(function (v) { io.observe(v); });
 }
 });
 }

 /* ============================================================
 Science accordion, exclusive (only one <details> open)
 ============================================================ */
 function initScienceAccordion() {
 var rows = document.querySelectorAll('.vsci4-row');
 if (rows.length < 2) return;
 rows.forEach(function (row) {
 row.addEventListener('toggle', function () {
 if (row.open) {
 rows.forEach(function (other) {
 if (other !== row && other.open) other.removeAttribute('open');
 });
 }
 });
 });
 }

 /* ============================================================
 Chat animation, reveal messages one by one
 ============================================================ */
 function initChatAnimation() {
 var thread = document.querySelector('.gc-chat-thread');
 if (!thread) return;
 var chatRows = Array.from(thread.querySelectorAll('.gc-chat-row:not(.gc-chat-typing-row)'));
 var typingRow = thread.querySelector('.gc-chat-typing-row');
 var delivered = thread.querySelector('.gc-chat-delivered');
 var hookWrap = document.querySelector('.vgc6-hook-wrap');

 // Build a sequence: for "them" messages, show typing dots first then the message
 // For "you" messages, just show the message with a short delay
 var sequence = [];
 chatRows.forEach(function (row) {
 var bubble = row.querySelector('.gc-chat-bubble');
 var isThem = bubble && bubble.classList.contains('gc-chat-bubble--them');
 if (isThem && typingRow) {
 // Show typing indicator, wait, hide it, then show message
 sequence.push({ action: 'show-typing', delay: 400 });
 sequence.push({ action: 'hide-typing-show-msg', row: row, delay: 1200 });
 } else {
 sequence.push({ action: 'show-msg', row: row, delay: 500 });
 }
 });

 var idx = 0;
 function runNext() {
 if (idx >= sequence.length) {
 // All messages done, show delivered + hook, keep typing dots visible (infinite bounce)
 if (typingRow) typingRow.classList.add('is-visible');
 if (delivered) setTimeout(function () { delivered.classList.add('is-visible'); }, 400);
 if (hookWrap) setTimeout(function () { hookWrap.classList.add('is-visible'); }, 1000);
 return;
 }
 var step = sequence[idx];
 idx++;
 if (step.action === 'show-typing') {
 if (typingRow) typingRow.classList.add('is-visible');
 setTimeout(runNext, step.delay);
 } else if (step.action === 'hide-typing-show-msg') {
 if (typingRow) typingRow.classList.remove('is-visible');
 setTimeout(function () {
 step.row.classList.add('is-visible');
 setTimeout(runNext, step.delay);
 }, 200);
 } else {
 step.row.classList.add('is-visible');
 setTimeout(runNext, step.delay);
 }
 }

 // Use IntersectionObserver to start animation when chat section scrolls into view
 var section = thread.closest('.vgc6-section') || thread;
 var fired = false;
 function startAnimation() {
 if (fired) return;
 fired = true;
 setTimeout(runNext, 600);
 }

 if ('IntersectionObserver' in window) {
 var io = new IntersectionObserver(function (entries) {
 entries.forEach(function (entry) {
 if (entry.isIntersecting) {
 io.disconnect();
 startAnimation();
 }
 });
 }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
 io.observe(section);
 }

 // Fallback: scroll listener in case IntersectionObserver doesn't fire (e.g. overflow:clip)
 function checkScroll() {
 if (fired) { window.removeEventListener('scroll', checkScroll); return; }
 var rect = section.getBoundingClientRect();
 if (rect.top < window.innerHeight * 0.85 && rect.bottom > 0) {
 window.removeEventListener('scroll', checkScroll);
 startAnimation();
 }
 }
 window.addEventListener('scroll', checkScroll, { passive: true });
 setTimeout(checkScroll, 500);
 }

 /* ============================================================
 initSupplementFactsAlt used to live here and bound a SECOND open handler
 to data-gc-action="open-supplement-facts". The ingredients button carries
 that attribute and data-gc-sf-open, so it collected two open handlers and
 one close handler, and the scroll lock never fully released. Both
 attributes are now handled by the single selector in initSupplementFacts.
 ============================================================ */

 /* ============================================================
 AJAX Cart, Shrine-style side cart drawer.
 Intercepts /cart/add forms, fetches cart, renders items in a
 sliding drawer from the right. Full cart management (qty +/−,
 remove, checkout) without leaving the page.
 ============================================================ */
 function initAjaxCart() {
 // Welcome kit products, auto-added with subscriptions, made free by the
 // "Welcome Kit, Free with Subscription" automatic discount on Shopify.
 var WELCOME_KIT_HANDLES = ['premium-portable-heating-pad', 'stainless-steel-tumbler', 'satin-scrunchie'];
 // Chocolate product pages where the subscription welcome kit applies
 var CHOCOLATE_HANDLES = ['period-relief-bundle', 'period-relief-kit', 'period-relief-chocolate'];
 // The two rungs of the cart-drawer upsell ladder: pouch (one-time, $40) →
 // kit (one-time, $127 + $7 shipping) → kit (monthly subscription, free shipping).
 var POUCH_HANDLE = 'period-relief-chocolate';
 var KIT_HANDLE = 'period-relief-kit';
 // The pouch REFILL product (/products/period-relief-chocolate-subscription).
 // Its lines carry _buyonce, but only to suppress the welcome-kit gifts, which
 // belong to the Kit. It is not a one-time purchase and must not be labelled one.
 var SUB_POUCH_HANDLE = 'period-relief-chocolate-subscription';
 // The pouch listed inside the Welcome Kit box once the kit is in the cart.
 // It IS a real cart line, as of 2026-08-07. It used to be a virtual row, on
 // the reasoning that the Kit variant (SKU 200) "already ships the first
 // pouch" and its price already covers it ($93 today = kit + first pouch,
 // then $33 a month). That is true of the PRICE and false of everything
 // downstream: the warehouse packs LINE ITEMS, and there was no pouch line,
 // so orders #1284, #1285 and #1288 shipped the three gifts and no chocolate
 // at all. #1288 was on the 3-month plan, so that shopper paid for a
 // three-month supply and received none of it.
 // Still "Included" and not "FREE": it is what you are paying for, not a
 // gift on top.
 var SUB_POUCH_KIT_LABEL = 'Girl Chocolate';
 // The chocolate the Kit ships, added as a real cart line beside the Kit.
 // This is the SAME variant customers buy (GCPOUCH, the "1 Pouch" variant of
 // period-relief-chocolate), not a $0 duplicate product, so a Kit order
 // decrements pouch stock like any other sale. It is taken to $0 by the
 // gc-pouch-volume-rate discount function, which is the only mechanism that
 // can require the Kit to be in the cart: the "Welcome Kit - Free with Kit
 // Order" Basic discount targets PRODUCTS with a $40 subtotal minimum, so
 // putting the sellable pouch in it would make chocolate free on any
 // pouch-only order over $40.
 //
 // The `_kit_contents` property below is load-bearing twice over. It keeps
 // this line SEPARATE from any pouch the shopper chose (Shopify keys line
 // identity on variant + selling plan + properties) and it is what tells the
 // function which line to zero. Without it the function cannot distinguish
 // the Kit's own chocolate from a $34.99 sale, so it charges for both.
 var KIT_POUCH_PRODUCT_HANDLE = 'period-relief-chocolate';
 var KIT_POUCH_VARIANT_TITLE = '1 Pouch';
 var KIT_CONTENTS_PROP = '_kit_contents';
 var ONE_TIME_PLAN_LABEL = 'One-time purchase';
 var SUB_POUCH_PLAN_LABEL = 'Refills monthly';
 var KIT_SHIPPING_CENTS = 700; // "Express Tracked Shipping" on the General delivery profile
 // Fallbacks, used only until /products/period-relief-kit.js resolves; the live
 // numbers replace them on the next render so a price change never strands copy.
 var KIT_ONCE_FALLBACK = 12700;
 var KIT_FIRST_FALLBACK = 9300; // kit + first pouch on the monthly plan
 var KIT_RENEWAL_FALLBACK = 3300;
 // The kit upsell's ask is a FIXED number, on purpose. It used to be derived,
 // KIT_FIRST_FALLBACK minus whatever was already in the cart, which meant the
 // offer moved with the basket: $53.01 against one $39.99 pouch, less against
 // two, nothing once the cart passed $93. One offer became many, each with its
 // own odd cents, and none of them memorable. A flat $53 reads as a price and
 // stays legible next to the "$134 in extras" it is paired with.
 // Re-cut by hand if the kit or the pouch price moves.
 var KIT_UPSELL_ADDON_CENTS = 5300;
 // 2026-08-26 owner request: pause the add-to-cart Welcome Kit upsell on the
 // pouch PDP (period-relief-chocolate). Hides the bundle panel ONLY when the
 // cart does not yet contain the kit (the isBuyOnceCart-only branch below:
 // "Add $53, get $134 in extras" + "buy the kit once"). A cart that already
 // holds the kit (subscription gifts, or a one-time kit's own chocolate line)
 // keeps the panel rendering exactly as before, because it is the ONLY UI
 // that shows those lines are included: welcomeKitItems and kitPouchItems are
 // filtered OUT of the normal cart-line list (see mainItems above) and have
 // no other display. Set false to restore the upsell.
 var KIT_UPSELL_PAUSED = true;
 // Heating pad 4900 + tumbler 3500 + scrunchie 1000 + Girl Harmony Premium 4000.
 var WELCOME_KIT_VALUE_CENTS = 13400;
 var welcomeKitVariantIds = []; // [{handle, id}] populated on init
 var welcomeKitImages = {}; // { handle: image_url } populated on init, used by the cart drawer and the gifts modal

 // Build the side cart drawer DOM
 var overlay = document.createElement('div');
 overlay.className = 'gc-sidecart-overlay';
 document.body.appendChild(overlay);

 var drawer = document.createElement('div');
 drawer.className = 'gc-sidecart';
 drawer.innerHTML =
 '<div class="gc-sidecart__header">' +
 '<h3 class="gc-sidecart__title">Your Cart</h3>' +
 '<button type="button" class="gc-sidecart__close" aria-label="Close cart">' +
 '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
 '</button>' +
 '</div>' +
 '<div class="gc-sidecart__body"></div>' +
 '<div class="gc-sidecart__footer">' +
 '<div class="gc-sidecart__upsell" data-sidecart-upsell>' +
 '<div class="gc-sidecart__upsell-row">' +
 '<img class="gc-sidecart__upsell-img" data-upsell-img alt="Shipping Protection">' +
 '<div class="gc-sidecart__upsell-text">' +
 '<div class="gc-sidecart__upsell-titlerow">' +
 '<span class="gc-sidecart__upsell-name">Shipping Protection</span>' +
 '<span class="gc-sidecart__upsell-price">$2.99</span>' +
 '</div>' +
 '<span class="gc-sidecart__upsell-desc">Protect your order from loss, theft or damage during shipping</span>' +
 '</div>' +
 '<label class="gc-sidecart__toggle">' +
 '<input type="checkbox" checked data-upsell-check aria-label="Add Shipping Protection">' +
 '<span class="gc-sidecart__toggle-track"><span class="gc-sidecart__toggle-thumb"></span></span>' +
 '</label>' +
 '</div>' +
 '</div>' +
 '<div class="gc-sidecart__savings" data-sidecart-savings hidden><span>Savings</span><strong data-savings-amount></strong></div>' +
 '<div class="gc-sidecart__shipping" data-sidecart-shipping hidden>' +
 '<span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-2px;margin-right:6px;"><rect x="1" y="3" width="15" height="13"/><path d="m16 8 4 0 3 3v5h-7M5.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM18.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/></svg>Shipping</span>' +
 '<strong data-shipping-amount>FREE</strong>' +
 '</div>' +
 '<div class="gc-sidecart__subtotal"><span>Subtotal</span><strong class="gc-sidecart__total-price"></strong></div>' +
 '<a href="/checkout" class="gc-sidecart__checkout" data-sidecart-checkout>Check out</a>' +
 '<a href="/cart" class="gc-sidecart__viewcart">View full cart</a>' +
 /* Chat entry point for the one moment it earns its place: item chosen, price
    on screen, deciding. The floating bubble is scoped to the home page by
    gc-chat-scope.liquid, so this text link is how chat is reached from here.
    Rendered hidden and revealed only if the widget actually loaded, so an
    uninstalled app does not leave a link that does nothing. */
 '<button type="button" class="gc-sidecart__chat" data-sidecart-chat hidden>Questions? Chat with us</button>' +
 '</div>';
 document.body.appendChild(drawer);

 /* The chat widget mounts late, so ask a few times before giving up on the link. */
 (function bindChatLink() {
 var link = drawer.querySelector('[data-sidecart-chat]');
 if (!link) return;
 var tries = 0;
 var t = setInterval(function () {
 tries++;
 if (window.gcChatAvailable && window.gcChatAvailable()) {
 link.hidden = false;
 clearInterval(t);
 } else if (tries > 40) {
 clearInterval(t);
 }
 }, 300);
 link.addEventListener('click', function () {
 if (window.gcOpenChat) window.gcOpenChat();
 });
 }());

 var body = drawer.querySelector('.gc-sidecart__body');
 var totalEl = drawer.querySelector('.gc-sidecart__total-price');
 var footerEl = drawer.querySelector('.gc-sidecart__footer');
 var upsellCheck = drawer.querySelector('[data-upsell-check]');
 var upsellEl = drawer.querySelector('[data-sidecart-upsell]');
 var upsellImg = drawer.querySelector('[data-upsell-img]');
 var savingsEl = drawer.querySelector('[data-sidecart-savings]');
 var savingsAmt = drawer.querySelector('[data-savings-amount]');
 var shippingEl = drawer.querySelector('[data-sidecart-shipping]');
 var shippingAmt = drawer.querySelector('[data-shipping-amount]');

 /* Shipping protection upsell toggle */
 var shippingProtectionVariantId = null; // will be fetched
 var shippingProtectionInCart = false;
 var shippingProtectionUserRemoved = false; // set when shopper toggles it off

 // Fetch the shipping protection product, variant ID + featured image
 function loadShippingProtection(handle) {
 return fetch('/products/' + handle + '.js')
 .then(function(r) { if (!r.ok) throw new Error('not found'); return r.json(); })
 .then(function(product) {
 if (product && product.variants && product.variants.length > 0) {
 shippingProtectionVariantId = product.variants[0].id;
 if (upsellImg && product.featured_image) upsellImg.src = product.featured_image;
 }
 });
 }
 loadShippingProtection('shipping-protection').catch(function() {
 loadShippingProtection('shipping-insurance').catch(function() {});
 });

 // Kit lookup memos. These MUST be declared ABOVE the first getKitProduct()
 // call, which is the loadKitInfo() on the next line.
 //
 // They used to sit next to getKitProduct() ~280 lines down. `var` hoists the
 // declaration, so the call below still ran and still filled kitProductPromise,
 // but the `= null` initialiser executes in place, later, and wiped it. The
 // result works and does not cache, which is why nothing caught it: no error,
 // no failing test, correct output. Harmless until 2178451 put kitPouchFor()
 // in front of /cart/add.js, after which every shopper's FIRST add refetched
 // both product JSONs while the add request sat waiting on them. Measured on
 // the live PDP 2026-08-21: 130ms idle, 1.9s while the page was still loading.
 var kitProductPromise = null;
 var kitPouchPromise = null;

 // Warm the kit prices so the upsell copy renders with live numbers rather
 // than the fallbacks. If the drawer is already open when it lands, re-render.
 loadKitInfo().then(function () {
 if (kitInfo && drawer.classList.contains('is-open')) fetchAndRender();
 });

 // Warm the Kit's chocolate variant on the same pass. kitPouchFor() awaits
 // BOTH memos before /cart/add.js is sent, so whatever is unresolved at click
 // time is latency the shopper pays. This one was never prefetched at all, so
 // /products/period-relief-chocolate.js was always a cold hit on the first add.
 // getKitPouchVariantId() resolves to null rather than throwing on every
 // failure path, so this cannot take add-to-cart down with it.
 getKitPouchVariantId();

 // Fetch welcome kit product variant IDs + featured images.
 // The images feed both the cart-drawer upsell rows and the
 // [data-gc-wk-img] thumbnails used by the gifts modal.
 WELCOME_KIT_HANDLES.forEach(function(handle) {
 fetch('/products/' + handle + '.js')
 .then(function(r) { return r.json(); })
 .then(function(product) {
 if (!product) return;
 if (product.variants && product.variants.length > 0) {
 welcomeKitVariantIds.push({ handle: handle, id: product.variants[0].id });
 }
 if (product.featured_image) {
 var img = product.featured_image;
 // Use a sized variant (Shopify size suffix) for the drawer thumbnails
 var sized = img.replace(/(\.[^.]+)$/, '_160x$1');
 welcomeKitImages[handle] = sized;
 // Fan out to any modal thumbnails waiting for this image
 document.querySelectorAll('[data-gc-wk-img="' + handle + '"]').forEach(function (el) {
 el.src = sized;
 });
 }
 })
 .catch(function() {});
 });

 // The "Girl Chocolate / Included" row used to prefetch its thumbnail here.
 // It no longer needs to: the row is a real cart line and carries its own
 // image. The fetch is gone rather than repointed because the handle it used
 // (period-relief-chocolate-subscription) has 404'd since the PDP handle swap
 // on 2026-08-06, which is the whole reason that row was showing an emoji.

 if (upsellCheck) {
 upsellCheck.addEventListener('change', function() {
 if (!shippingProtectionVariantId) return;
 if (upsellCheck.checked) {
 // Add shipping protection
 shippingProtectionUserRemoved = false;
 fetch('/cart/add.js', {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify({ items: [{ id: shippingProtectionVariantId, quantity: 1 }] })
 }).then(function() { fetchAndRender(); }).catch(function() {});
 } else {
 // Remove shipping protection, remember the shopper opted out
 shippingProtectionUserRemoved = true;
 fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
 var spItem = cart.items.find(isShippingProtection);
 if (spItem) updateQty(spItem.key, 0);
 }).catch(function() {});
 }
 });
 }

 // body{overflow:hidden} stops the page on Android and desktop but iOS
 // Safari ignores it, so while the drawer is open we also swallow touchmove
 // anywhere outside the cart's own scroll area. Moves that start inside
 // .gc-sidecart__body are left alone, so the cart scrolls natively;
 // overscroll-behavior: contain keeps it from chaining to the page at the
 // ends. Pinning the body with position:fixed also works but kills the
 // drawer's inner scrolling on touch, so do not go back to it.
 function onCartTouchMove(e) {
 if (e.cancelable && !body.contains(e.target)) e.preventDefault();
 }

 // The chat launcher lives in a shadow root, so neither theme.css nor a style
 // on the host can reach it. Inject the rule inside the shadow root instead.
 // (Kept as a style injection rather than gcChat.showLauncher() because this is
 // a temporary, media-query-scoped hide tied to the drawer being open, and it
 // must not clobber the product-page gate that gc-chat-scope owns.)
 function toggleChatLauncher(hide) {
 var host = document.getElementById('gc-chat-widget');
 if (!host || !host.shadowRoot) return;
 var tag = host.shadowRoot.getElementById('gc-cart-hide-chat');
 if (hide) {
 if (!tag) {
 tag = document.createElement('style');
 tag.id = 'gc-cart-hide-chat';
 tag.textContent = '@media (max-width: 749px){.launcher{display:none !important;}}';
 host.shadowRoot.appendChild(tag);
 }
 } else if (tag) {
 tag.parentNode.removeChild(tag);
 }
 }

 // Guarded so a second openDrawer (a re-render, a second Add) cannot take a
 // second lock that nothing will release, and closeDrawer on an already-closed
 // drawer cannot release someone else's.
 var drawerOpen = false;
 function openDrawer() {
 drawer.classList.add('is-open');
 fitUpsellLine();
 overlay.classList.add('is-open');
 document.body.classList.add('gc-cart-open');
 // Was `document.body.style.overflow = 'hidden'`, a raw write to a global
 // that four other things in this file and every third-party popup also
 // write. body.gc-cart-open already applies overflow:hidden in CSS, so the
 // inline style added nothing except a way to clobber, and be clobbered by,
 // whatever else had locked the page.
 if (!drawerOpen) { drawerOpen = true; lockBodyScroll(); }
 document.addEventListener('touchmove', onCartTouchMove, { passive: false });
 toggleChatLauncher(true);
 }
 function closeDrawer() {
 drawer.classList.remove('is-open');
 overlay.classList.remove('is-open');
 document.body.classList.remove('gc-cart-open');
 if (drawerOpen) { drawerOpen = false; unlockBodyScroll(); }
 document.removeEventListener('touchmove', onCartTouchMove);
 toggleChatLauncher(false);
 }

 drawer.querySelector('.gc-sidecart__close').addEventListener('click', closeDrawer);
 overlay.addEventListener('click', closeDrawer);
 document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

 function formatMoney(cents) {
 return '$' + (cents / 100).toFixed(2);
 }
 // Whole dollars drop the ".00". The upsell lines are tight enough that three
 // characters of noise decide whether a line wraps.
 function formatMoneyShort(cents) {
 return (cents % 100 === 0) ? '$' + (cents / 100) : formatMoney(cents);
 }

 function isSubscriptionItem(item) {
 return item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
 }
 // A selling plan's NAME is doing two jobs on this storefront: it is printed as
 // the badge under the line, and it is the only cadence signal the cart has,
 // because cart.js exposes a plan's name and prices but never its interval.
 //
 // On 2026-08-06 Appstle plan 691337298209 was re-cut from MONTH x 1 to DAY x 28
 // and kept the name "Monthly Delivery". So the name now misstates the billing
 // frequency in both places at once: the badge reads MONTHLY DELIVERY, and the
 // cadence test falls through to "a month" on a plan that charges 13 times a
 // year. This map is the correction.
 //
 // THIS MIRRORS ADMIN AND WILL DRIFT. The right fix is renaming the option in
 // Appstle (Subscription Plans > Girl Chocolate Kit Subscription > the option >
 // Edit > name). Do that and DELETE the entry below rather than keeping both,
 // or the next person re-cutting the plan will change Appstle and be silently
 // overridden from here. Same coupling that already bit v-hero-pouch-sub's
 // volume_off_per_pouch setting.
 var PLAN_NAME_OVERRIDES = {
 '691337298209': 'Every 28 Days' // Kit, DAY x 28, still named "Monthly Delivery" in Appstle
 };
 function planDisplayName(alloc) {
 var plan = alloc && alloc.selling_plan;
 if (!plan) return '';
 return PLAN_NAME_OVERRIDES[String(plan.id)] || plan.name || '';
 }
 // Plain-language explanation of how a subscription line is billed, shown in
 // the cart drawer so shoppers understand: you pay once today (the kit + first
 // pouch), then a smaller recurring charge for just the pouch after that.
 // Reads the real Shopify selling-plan allocation so it stays correct if the
 // plan pricing changes. The kit steps down after order 1 (first order price
 // != ongoing price); a flat pouch subscription renews at the same price.
 function subscriptionBillingNote(item) {
 if (!isSubscriptionItem(item)) return '';
 var alloc = item.selling_plan_allocation;
 var name = planDisplayName(alloc);
 var adj = alloc.price_adjustments || [];
 // No default. This used to fall through to 'a month', which is an assertion
 // the code cannot check: cart.js exposes a selling plan's NAME and prices but
 // never its billing interval, so a plan whose name carries no cadence would
 // silently be described as monthly. That is how the Kit came to promise
 // "$33.00 a month" the moment its plan was re-cut to 28 days. When the cadence
 // is unknown the sentence now simply omits it rather than inventing one.
 var cadence = null;
 if (/3.?\s?month/i.test(name)) cadence = 'every 3 months';
 else if (/28.?\s?day/i.test(name)) cadence = 'every 28 days';
 else if (/month/i.test(name)) cadence = 'a month';
 var every = cadence ? ' ' + cadence : '';
 // Ongoing price = the cheaper adjustment (the pouch-only recurring charge);
 // the first order is higher because it includes the Welcome Kit.
 var recurring = null;
 if (adj.length) {
 recurring = adj.reduce(function (m, a) { return a.price < m ? a.price : m; }, adj[0].price);
 }
 var firstPrice = (item.final_line_price != null) ? item.final_line_price
 : (alloc.per_delivery_price != null ? alloc.per_delivery_price : recurring);
 var icon = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none;margin-top:1px"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>';
 var msg;
 // Deliberately does NOT restate the first charge. It is already the line
 // price two rows up, and repeating it was most of the sentence.
 //
 // What CANNOT be cut, whatever else goes: the recurring amount, how often it
 // recurs, and that it can be stopped. Those three are the auto-renewal
 // disclosure, and "Then" is what marks the price above as the one-off.
 // Name the thing. "Then $33.00 every 28 days" states a charge and no
 // product, which reads like a fee rather than a delivery; the first cut of
 // this sentence dropped the noun along with the repeated price.
 // "Ready for every cycle" ONLY on the 28-day plan, and that is correctness
 // rather than style. 28 days IS the cycle, which is why the sentence can
 // carry the reason for the cadence without spending extra words on it. On
 // the 3-month plan one delivery covers THREE cycles, so the same words would
 // promise something the plan does not do. No known cadence, no claim.
 var tail = (cadence === 'every 28 days')
 ? ' Ready for every cycle, pause or cancel anytime.'
 : ' Pause or cancel anytime.';
 if (recurring != null && recurring !== firstPrice) {
 msg = 'Then a fresh pouch of chocolate' + every + ', ' + formatMoney(recurring) + '.' + tail;
 } else if (recurring != null) {
 msg = 'A fresh pouch of chocolate ships' + every + ', ' + formatMoney(recurring) + '.' + tail;
 } else {
 return '';
 }
 return '<div class="gc-sidecart__item-billing">' + icon + '<span>' + msg + '</span></div>';
 }
 function isShippingProtection(item) {
 var t = (item.product_title || '').toLowerCase();
 return t.indexOf('shipping protection') > -1 || t.indexOf('shipping insurance') > -1;
 }
 function isWelcomeKitItem(item) {
 return WELCOME_KIT_HANDLES.indexOf(item.handle) > -1 || item.product_type === 'Welcome Kit';
 }
 function isChocolatePage() {
 return CHOCOLATE_HANDLES.some(function(h) { return location.pathname.indexOf('/products/' + h) > -1; });
 }
 function isBuyOnceLine(item) {
 return !!(item && item.properties && (item.properties._buyonce === 'true' || item.properties._buyonce === true));
 }
 function isKitItem(item) {
 return !!item && item.handle === KIT_HANDLE;
 }
 // The Kit's own chocolate. Not a main item (it is part of the Kit, not a
 // separate purchase) and not a welcome-kit gift, so it is partitioned out on
 // its own. Keyed on the PROPERTY and not the handle: this is the same variant
 // a shopper can buy outright, and a pouch someone chose is a $34.99 sale that
 // belongs in the main list at full price.
 function isKitPouchItem(item) {
 // The gifts carry the same marker (it is what makes them free), so they have
 // to be excluded here or they would be pulled out of the Welcome Kit box and
 // rendered as chocolate rows.
 return isKitContentsItem(item) && !isWelcomeKitItem(item);
 }
 // Marks every line the Kit ships, chocolate and gifts alike. The discount
 // function frees exactly these, capped to what the Kit entitles, so an item
 // the shopper chose for themselves is a separate unflagged line and is
 // charged. That matters now the gifts are sold standalone too.
 function isKitContentsItem(item) {
 if (!item || !item.properties) return false;
 var v = item.properties[KIT_CONTENTS_PROP];
 return v === 'true' || v === true;
 }
 // The cart-add payload for one thing the Kit ships.
 function kitContentsLine(variantId, quantity) {
 var line = { id: variantId, quantity: quantity || 1, properties: {} };
 line.properties[KIT_CONTENTS_PROP] = 'true';
 return line;
 }
 // A cart counts as a subscription only when a line carries a real Shopify
 // selling plan, or a _plan tag that isn't the one-time marker. Buy-once lines
 // also carry _plan ("One-time purchase"), so they must be excluded explicitly,
 // otherwise a one-time kit would show FREE shipping and pick up FREESHIPSUB.
 function isSubscriptionCart(cart) {
 return (cart.items || []).some(function (it) {
 if (!it || isBuyOnceLine(it)) return false;
 return !!(it.selling_plan_allocation || (it.properties && it.properties._plan));
 });
 }
 function postCart(url, payload) {
 return fetch(url, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify(payload)
 }).then(function (r) {
 if (!r.ok) throw new Error(url + ' failed');
 return r.json();
 });
 }
 // Kit product JSON (variant + Appstle selling plans), fetched once and reused
 // by both rungs of the drawer upsell ladder.
 //
 // kitProductPromise / kitPouchPromise are declared at the TOP of initAjaxCart,
 // beside the prefetch that fills them. Do not move the declarations back down
 // here: the `= null` initialiser would run after that prefetch and wipe it.
 function getKitProduct() {
 if (!kitProductPromise) {
 kitProductPromise = fetch('/products/' + KIT_HANDLE + '.js')
 .then(function (r) { if (!r.ok) throw new Error('kit not found'); return r.json(); })
 .catch(function (e) { kitProductPromise = null; throw e; });
 }
 return kitProductPromise;
 }
 // The $0 chocolate line that rides along with every Kit. Resolved once and
 // cached. Resolves to null rather than throwing: a Kit that reaches checkout
 // with no chocolate line is the bug being fixed here, but a Kit that cannot
 // be added to the cart at all is worse, so a failure here must never take
 // the add-to-cart down with it.
 function getKitPouchVariantId() {
 if (!kitPouchPromise) {
 kitPouchPromise = fetch('/products/' + KIT_POUCH_PRODUCT_HANDLE + '.js')
 .then(function (r) { if (!r.ok) throw new Error('kit pouch not found'); return r.json(); })
 .then(function (p) {
 var variants = (p && p.variants) || [];
 // Matched on title, not position: this product also carries 2-pack and
 // 3-pack variants, and the discount function only ever zeroes single
 // pouches, so picking a pack here would be charged in full.
 for (var i = 0; i < variants.length; i++) {
 if (variants[i].title === KIT_POUCH_VARIANT_TITLE) return variants[i].id;
 }
 return null;
 })
 .catch(function () { return null; });
 }
 return kitPouchPromise;
 }
 // How many pouches a Kit line ships. The buy box sells the 3-month plan as
 // "Kit + 3-month supply" and every other way of buying the Kit as one pouch.
 // Matched off the plan LABEL rather than a hardcoded Appstle plan id: the
 // label is what the shopper was shown and what _plan carries into the cart,
 // and the ids get re-cut (plan 691337298209 was re-cut to DAY x 28 on
 // 2026-08-06, which is why PLAN_NAME_OVERRIDES exists at all).
 function pouchesForKitPlan(planLabel) {
 return /3\s*-?\s*month|90\s*-?\s*day/i.test(planLabel || '') ? 3 : 1;
 }
 // Is this variant id the Kit? Compared as strings because the value coming
 // off a form input is one and the value off /products/*.js is a number.
 function isKitVariantId(kitProduct, variantId) {
 if (!kitProduct || !variantId) return false;
 return (kitProduct.variants || []).some(function (v) {
 return String(v.id) === String(variantId);
 });
 }
 // The chocolate line to add alongside a Kit, or null when what is being
 // added is not a Kit. Resolves rather than rejects on every failure path:
 // losing the chocolate line is the bug being fixed, but blocking the Kit
 // from being bought at all would be a worse one.
 function kitPouchFor(variantId, planLabel, kitQty) {
 if (!variantId) return Promise.resolve(null);
 return Promise.all([
 getKitProduct().catch(function () { return null; }),
 getKitPouchVariantId()
 ]).then(function (vals) {
 var kitProduct = vals[0];
 var pouchVariantId = vals[1];
 if (!pouchVariantId || !isKitVariantId(kitProduct, variantId)) return null;
 return kitContentsLine(
 pouchVariantId,
 Math.max(1, kitQty || 1) * pouchesForKitPlan(planLabel)
 );
 }).catch(function () { return null; });
 }
 // The refill product, fetched once. Needed by the subscribe upsell to carry
 // surplus pouches over onto the subscription rather than binning them.
 var subPouchProductPromise = null;
 function getSubPouchProduct() {
 if (!subPouchProductPromise) {
 subPouchProductPromise = fetch('/products/' + SUB_POUCH_HANDLE + '.js')
 .then(function (r) { if (!r.ok) throw new Error('refill not found'); return r.json(); })
 .catch(function (e) { subPouchProductPromise = null; throw e; });
 }
 return subPouchProductPromise;
 }
 // How many pouches a cart line actually represents. Read off the variant TITLE
 // ("1 Pouch" / "2 Pouches" / "3 Pouches") rather than a hardcoded variant map,
 // so a new pack size counts correctly the day it is created instead of the day
 // someone remembers to update this file.
 function pouchesInLine(item) {
 if (!item) return 0;
 if (item.handle === SUB_POUCH_HANDLE) {
 var m = /(\d+)/.exec(item.variant_title || '');
 return (m ? parseInt(m[1], 10) : 1) * item.quantity;
 }
 if (item.handle === POUCH_HANDLE) return item.quantity;
 return 0;
 }
 // The single-pouch variant and the plan the refill page itself would post.
 // Same rule the buy box uses: first selling_plan_allocation wins.
 function subPouchSingle(product) {
 var variants = (product && product.variants) || [];
 var single = variants.filter(function (v) { return /^\s*1\b/.test(v.title || ''); })[0] || variants[0];
 if (!single) return null;
 var alloc = (single.selling_plan_allocations || [])[0];
 return { id: single.id, planId: alloc ? alloc.selling_plan_id : null };
 }
 // Kit pricing, resolved once from the storefront so the upsell copy never
 // quotes a stale number: one-off price, first subscription order, and the
 // ongoing renewal (the cheaper of the plan's price adjustments).
 var kitInfo = null;
 function loadKitInfo() {
 return getKitProduct().then(function (p) {
 var v = p && p.variants && p.variants[0];
 if (!v) return null;
 var alloc = v.selling_plan_allocations && v.selling_plan_allocations[0];
 var adj = (alloc && alloc.price_adjustments) || [];
 kitInfo = {
 oncePrice: v.price,
 firstPrice: alloc ? alloc.price : v.price,
 renewalPrice: adj.length
 ? adj.reduce(function (m, a) { return a.price < m ? a.price : m; }, adj[0].price)
 : null
 };
 return kitInfo;
 }).catch(function () { return null; });
 }

 // First selling plan on the kit = Monthly Delivery (same rule the buy-box uses).
 function kitMonthlyPlan(kitProduct) {
 var variant = kitProduct && kitProduct.variants && kitProduct.variants[0];
 var alloc = variant && variant.selling_plan_allocations && variant.selling_plan_allocations[0];
 if (!alloc) return null;
 var name = 'Monthly Delivery';
 (kitProduct.selling_plan_groups || []).forEach(function (g) {
 (g.selling_plans || []).forEach(function (p) {
 if (p.id === alloc.selling_plan_id && p.name) name = p.name;
 });
 });
 return { id: alloc.selling_plan_id, name: name };
 }
 // Resolve the 3 welcome-kit variant IDs (already loaded, or fetched on demand)
 function ensureWelcomeKitVariants() {
 if (welcomeKitVariantIds.length === WELCOME_KIT_HANDLES.length) return Promise.resolve(welcomeKitVariantIds);
 return Promise.all(WELCOME_KIT_HANDLES.map(function (h) {
 return fetch('/products/' + h + '.js').then(function (r) { return r.json(); })
 .then(function (p) { return { handle: h, id: p.variants[0].id }; })
 .catch(function () { return null; });
 })).then(function (arr) { return arr.filter(Boolean); });
 }
 // Add the 3 welcome kit products (only those not already in the cart)
 function addWelcomeKit() {
 var resolve = welcomeKitVariantIds.length
 ? Promise.resolve(welcomeKitVariantIds)
 : Promise.all(WELCOME_KIT_HANDLES.map(function(h) {
 return fetch('/products/' + h + '.js').then(function(r) { return r.json(); })
 .then(function(p) { return { handle: h, id: p.variants[0].id }; })
 .catch(function() { return null; });
 })).then(function(arr) { return arr.filter(Boolean); });
 return resolve.then(function(kit) {
 if (!kit.length) return;
 return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
 var toAdd = kit.filter(function(w) {
 return !cart.items.some(function(i) { return i.variant_id === w.id; });
 }).map(function(w) { return kitContentsLine(w.id, 1); });
 if (!toAdd.length) return;
 return fetch('/cart/add.js', {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify({ items: toAdd })
 });
 });
 });
 }

 function renderCart(cart) {
 // Update badge
 var badge = document.querySelector('.gc-nav__cart-count');
 if (badge) {
 badge.textContent = cart.item_count;
 badge.setAttribute('data-empty', cart.item_count === 0 ? 'true' : 'false');
 }

 // Classify cart items
 shippingProtectionInCart = cart.items.some(isShippingProtection);
 if (upsellCheck) upsellCheck.checked = shippingProtectionInCart;
 var welcomeKitItems = cart.items.filter(isWelcomeKitItem);
 var kitPouchItems = cart.items.filter(isKitPouchItem);
 var mainItems = cart.items.filter(function(i) {
 return !isShippingProtection(i) && !isWelcomeKitItem(i) && !isKitPouchItem(i);
 });
 // The Kit leads, always. Shopify orders cart lines by when they were added,
 // so taking the upsell used to leave the Kit BELOW the pouch it was supposed
 // to be an upgrade from, with the Welcome Kit box floating under both. Sort
 // is display-only and stable, so everything else keeps its add order.
 mainItems.sort(function (a, b) {
 return (isKitItem(b) ? 1 : 0) - (isKitItem(a) ? 1 : 0);
 });

 // Orphan cleanup, welcome kit / protection left with no real product:
 // one clear call → one clean render, no flicker.
 if (mainItems.length === 0 && (welcomeKitItems.length || kitPouchItems.length || shippingProtectionInCart)) {
 fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
 .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
 return;
 }

 // The gifts belong to the Kit. Remove the Kit while anything else is still in
 // the cart and they are orphaned, which goes wrong three ways at once:
 //   - the box keeps saying the welcome kit is included, because their being
 //     present is exactly what marks the cart as already having it
 //   - the upsell that would sell the Kit back is therefore suppressed
 //   - they stay at $0. "Welcome Kit - Free with Kit Order" only requires a $40
 //     subtotal, so a cart of pouches alone can carry $84 of gifts to checkout
 // Dropping them restores all three: no gift lines, so a _buyonce pouch marks
 // the cart buy-once again and the upsell comes back.
 // The Kit's own chocolate is orphaned by the same move for a fourth reason:
 // it is a $0 line, so a cart that kept it would ship free chocolate.
 if ((welcomeKitItems.length || kitPouchItems.length) && !mainItems.some(isKitItem)) {
 var orphaned = {};
 welcomeKitItems.forEach(function (g) { orphaned[g.key] = 0; });
 kitPouchItems.forEach(function (g) { orphaned[g.key] = 0; });
 postCart('/cart/update.js', { updates: orphaned })
 .then(renderCart).catch(function () {});
 return;
 }

 if (cart.item_count === 0) {
 body.innerHTML = '<div class="gc-sidecart__empty">' +
 '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="opacity:0.3;margin-bottom:12px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
 '<p>Your cart is empty</p>' +
 '<a href="/products/period-relief-kit" class="gc-sidecart__shopbtn">Start shopping</a>' +
 '</div>';
 footerEl.style.display = 'none';
 totalEl.textContent = '$0.00';
 return;
 }

 footerEl.style.display = '';
 totalEl.textContent = formatMoney(cart.total_price);

 // Savings line, total of all discounts applied (incl. the free welcome kit)
 var savings = cart.total_discount || 0;
 if (savingsEl && savingsAmt) {
 if (savings > 0) {
 savingsAmt.textContent = '−' + formatMoney(savings);
 savingsEl.removeAttribute('hidden');
 } else {
 savingsEl.setAttribute('hidden', '');
 }
 }

 // Free shipping line, only shown when the cart contains a subscription
 // (monthly or 3-month). Buy-once carts hide it; they'll see the $7
 // shipping charge appear at checkout instead.
 //
 // Also auto-prepend the FREESHIPSUB discount code to the checkout link
 // so the customer gets free shipping at checkout (without using the
 // subscription app). Buy-once carts go straight to /checkout and pay
 // the default rate. The discount code itself was created via Shopify
 // Admin API in round 19 - see Shopify admin > Discounts > FREESHIPSUB.
 if (shippingEl) {
 var hasSubscription = isSubscriptionCart(cart);
 var kitOnceCart = !hasSubscription && mainItems.some(isKitItem);
 // A one-time pouch still ships free (its own "Pouch - free shipping"
 // profile); a one-time kit sits on the General profile and pays $7.
 var showsFreeShipping = hasSubscription || (cart.items || []).some(function (it) {
 return it && (it.selling_plan_allocation || (it.properties && it.properties._plan));
 });
 if (kitOnceCart) {
 if (shippingAmt) shippingAmt.textContent = formatMoney(KIT_SHIPPING_CENTS);
 shippingEl.removeAttribute('hidden');
 } else if (showsFreeShipping) {
 if (shippingAmt) shippingAmt.textContent = 'FREE';
 shippingEl.removeAttribute('hidden');
 } else {
 shippingEl.setAttribute('hidden', '');
 }
 var checkoutLink = drawer.querySelector('[data-sidecart-checkout]');
 if (checkoutLink) {
 checkoutLink.setAttribute('href', hasSubscription ? '/discount/FREESHIPSUB?redirect=%2Fcheckout' : '/checkout');
 }
 }

 // Pre-check / auto-add shipping protection when there are real items
 if (mainItems.length > 0 && !shippingProtectionInCart && !shippingProtectionUserRemoved && shippingProtectionVariantId) {
 fetch('/cart/add.js', {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify({ items: [{ id: shippingProtectionVariantId, quantity: 1 }] })
 }).then(function() { fetchAndRender(); }).catch(function() {});
 }

 // Show/hide upsell
 if (upsellEl) upsellEl.style.display = mainItems.length > 0 ? '' : 'none';

 var html = '';
 mainItems.forEach(function (item) {
 var imgSrc = item.image ? item.image.replace(/(\.[^.]+)$/, '_200x$1') : '';
 // Plan label priority: real Shopify selling plan name (when Appstle is
 // wired up) → the refill product's own label → the _plan line-item property
 // we set from the buy-box.
 //
 // The refill pouch has to be named here rather than read off _plan, because
 // every buy-box on that page posts _buyonce and theme.js stamps _plan with
 // ONE_TIME_PLAN_LABEL for anything carrying it. That flag means "do not add
 // the welcome-kit gifts", not "this is a one-off", and there are four such
 // forms on the page (hero, certifications, mini-CTA, final CTA). Keying on
 // the cart line's handle fixes all four, and any future one, in one place.
 var planName = isSubscriptionItem(item)
 ? planDisplayName(item.selling_plan_allocation)
 : (item.handle === SUB_POUCH_HANDLE
 ? SUB_POUCH_PLAN_LABEL
 : (item.properties && item.properties._plan ? item.properties._plan : ''));
 // Icon follows the LABEL, not the _buyonce flag, or the refill line would
 // read "Refills monthly" next to a shopping bag.
 var planIcon = planName === ONE_TIME_PLAN_LABEL ? 'shopping_bag' : 'autorenew';

 html += '<div class="gc-sidecart__item" data-key="' + item.key + '">' +
 '<div class="gc-sidecart__item-img">' +
 (imgSrc ? '<img src="' + imgSrc + '" alt="' + item.product_title + '" loading="lazy">' : '') +
 '</div>' +
 '<div class="gc-sidecart__item-info">' +
 '<div class="gc-sidecart__item-title">' + item.product_title + '</div>' +
 (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="gc-sidecart__item-variant">' + item.variant_title + '</div>' : '') +
 (planName ? '<div class="gc-sidecart__item-plan"><span class="material-symbols-rounded" style="font-size:13px;vertical-align:-2px">' + planIcon + '</span> ' + planName + '</div>' : '') +
 subscriptionBillingNote(item) +
 '<div class="gc-sidecart__item-bottom">' +
 '<div class="gc-sidecart__qty-wrap">' +
 '<button type="button" class="gc-sidecart__qty-btn" data-action="minus" aria-label="Decrease quantity">−</button>' +
 '<span class="gc-sidecart__qty-val">' + item.quantity + '</span>' +
 '<button type="button" class="gc-sidecart__qty-btn" data-action="plus" aria-label="Increase quantity">+</button>' +
 '</div>' +
 '<div class="gc-sidecart__item-price">' + formatMoney(item.final_line_price) + '</div>' +
 '</div>' +
 '</div>' +
 '<button type="button" class="gc-sidecart__item-remove" data-action="remove" aria-label="Remove item">' +
 '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
 '</button>' +
 '</div>';
 });

 // "Buy-once" here means one thing only: THE WELCOME KIT IS NOT IN THIS ORDER.
 //
 // It used to mean "some line carries _buyonce", which is a different question
 // and gave the wrong answer as soon as both were true at once. The refill pouch
 // stamps _buyonce on every line (see SUB_POUCH_HANDLE above: it means "do not
 // fire addWelcomeKit for this product", not "this cart is a one-off"), so a Kit
 // subscription plus one refill rendered the box as "0 / 4, NOT INCLUDED" across
 // three gifts that were sitting in the same cart at $0. The shopper was being
 // told a benefit they already had was missing.
 //
 // The gifts being present is therefore decisive and is checked first. Only one
 // welcome kit is ever given per order, so their presence settles it no matter
 // how many qualifying products or _buyonce lines are alongside them.
 var isBuyOnceCart = welcomeKitItems.length === 0 && mainItems.some(isBuyOnceLine);

 // Welcome Kit group.
 // Subscription mode → show the 3 real cart items as free.
 // Buy-once mode → show all 3 as greyed-out "Not included" virtual rows
 // (nothing extra is in the cart) + Upgrade-to-monthly CTA.
 if (welcomeKitItems.length || kitPouchItems.length || (isBuyOnceCart && !KIT_UPSELL_PAUSED)) {
 // "0 / 4" counted the chocolate as missing back when it was never a cart
 // line. It is one now, and on a one-time Kit it is the one thing in the
 // box the shopper does get, so say 1 / 4 rather than telling them
 // something they paid for is not included.
 var bundleBadge = isBuyOnceCart ? (kitPouchItems.length ? '1 / 4' : '0 / 4') : 'FREE';
 html += '<div class="gc-sidecart__bundle' + (isBuyOnceCart ? ' is-buyonce' : '') + '">' +
 '<div class="gc-sidecart__bundle-header">' +
 '<span class="material-symbols-rounded" style="font-size:16px;color:var(--gc-purple-500)">redeem</span>' +
 '<span>Welcome Kit</span>' +
 '<span class="gc-sidecart__bundle-badge">' + bundleBadge + '</span>' +
 '</div>' +
 '<div class="gc-sidecart__bundle-items">';

 // The chocolate leads the box, because it is the thing being bought
 // rather than a gift, and it is rendered on BOTH branches now: the Kit
 // ships a pouch on the one-time plan too, so it is in the cart either
 // way. The thumbnail comes off the cart line itself rather than a
 // separate product fetch. The old row fetched
 // /products/period-relief-chocolate-subscription.js for its image, and
 // that handle stopped resolving when the PDP handles were swapped on
 // 2026-08-06, so the fetch 404'd and the row had been silently falling
 // back to a 🍫 emoji ever since.
 kitPouchItems.forEach(function (kp) {
 var kpThumb = kp.image ? kp.image.replace(/(\.[^.]+)$/, '_120x$1') : '';
 html += '<div class="gc-sidecart__wk-line">' +
 '<span class="gc-sidecart__wk-thumb">' + (kpThumb ? '<img src="' + kpThumb + '" alt="">' : '🍫') + '</span>' +
 '<span class="gc-sidecart__wk-name">' + SUB_POUCH_KIT_LABEL +
 (kp.quantity > 1 ? ' &times;' + kp.quantity : '') + '</span>' +
 '<span class="gc-sidecart__wk-price"><span class="gc-sidecart__wk-included">Included</span></span>' +
 '</div>';
 });

 if (isBuyOnceCart) {
 // All three gifts shown as greyed virtual rows, none are in cart.
 var gifts = [
 { handle: 'premium-portable-heating-pad', name: 'Heating Pad', value: 4900 },
 { handle: 'stainless-steel-tumbler', name: 'Tumbler', value: 3500 },
 { handle: 'satin-scrunchie', name: 'Scrunchie', value: 1000 }
 ];
 gifts.forEach(function (g) {
 var thumb = welcomeKitImages[g.handle];
 html += '<div class="gc-sidecart__wk-line gc-sidecart__wk-line--missing">' +
 '<span class="gc-sidecart__wk-thumb">' + (thumb ? '<img src="' + thumb + '" alt="">' : '🎁') + '</span>' +
 '<span class="gc-sidecart__wk-name">' + g.name + '</span>' +
 '<span class="gc-sidecart__wk-price">' +
 '<s class="gc-sidecart__wk-was">' + formatMoney(g.value) + '</s>' +
 '<span class="gc-sidecart__wk-missing">Not included</span>' +
 '</span>' +
 '</div>';
 });
 } else {
 // Match the Free Member Gifts modal values exactly so the total
 // savings on screen is consistently $94 ($49 + $35 + $10) no matter
 // what the Shopify line price comes back as.
 var WK_RETAIL = {
 'premium-portable-heating-pad': 4900,
 'stainless-steel-tumbler': 3500,
 'satin-scrunchie': 1000
 };
 welcomeKitItems.forEach(function (wi) {
 var wImg = wi.image ? wi.image.replace(/(\.[^.]+)$/, '_120x$1') : '';
 var isFree = wi.final_line_price === 0;
 var retail = WK_RETAIL[wi.handle] || wi.original_line_price;
 var priceHtml = (retail > wi.final_line_price)
 ? '<s class="gc-sidecart__wk-was">' + formatMoney(retail) + '</s>'
 : '';
 priceHtml += '<span class="gc-sidecart__wk-free">' + (isFree ? 'FREE' : formatMoney(wi.final_line_price)) + '</span>';
 html += '<div class="gc-sidecart__wk-line">' +
 '<span class="gc-sidecart__wk-thumb">' + (wImg ? '<img src="' + wImg + '" alt="">' : '🎁') + '</span>' +
 '<span class="gc-sidecart__wk-name">' + wi.product_title + '</span>' +
 '<span class="gc-sidecart__wk-price">' + priceHtml + '</span>' +
 '</div>';
 });
 }

 // Girl Harmony Premium - a digital perk (1-year app membership, $40 value),
 // not a physical cart line, shown as a 4th welcome-kit gift. Free with a
 // subscription; "not included" in buy-once mode.
 var ghIcon = (window.GC_ASSETS && window.GC_ASSETS.ghIcon) || '';
 var ghThumb = ghIcon ? '<img src="' + ghIcon + '" alt="">' : '📱';
 var ghPrice = isBuyOnceCart
 ? '<s class="gc-sidecart__wk-was">$40</s><span class="gc-sidecart__wk-missing">Not included</span>'
 : '<s class="gc-sidecart__wk-was">$40</s><span class="gc-sidecart__wk-free">FREE</span>';
 html += '<div class="gc-sidecart__wk-line' + (isBuyOnceCart ? ' gc-sidecart__wk-line--missing' : '') + '">' +
 '<span class="gc-sidecart__wk-thumb gc-sidecart__wk-thumb--gh">' + ghThumb + '</span>' +
 '<span class="gc-sidecart__wk-name">Girl Harmony Premium</span>' +
 '<span class="gc-sidecart__wk-price">' + ghPrice + '</span>' +
 '</div>';

 html += '</div>';
 if (isBuyOnceCart) {
 var plusIcon = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
 if (mainItems.some(isKitItem)) {
 // The kit is already in the cart as a one-off: the only rung left is the plan.
 html +=
 '<p class="gc-sidecart__bundle-note gc-sidecart__bundle-note--upsell">Subscribe and unlock all 4 perks</p>' +
 '<button type="button" class="gc-sidecart__upgrade" data-sidecart-subscribe>' +
 plusIcon +
 'Subscribe and save extra 25% + Free shipping' +
 '</button>';
 } else {
 // Pouch cart. Both offers at once, cheapest first: the subscription is the
 // primary button (it is $34 less than the one-off kit), and the one-off kit
 // stays reachable underneath for anyone who will not sign up for anything.
 var kitOnce = (kitInfo && kitInfo.oncePrice) || KIT_ONCE_FALLBACK;
 var kitRenewal = (kitInfo && kitInfo.renewalPrice) || KIT_RENEWAL_FALLBACK;
 // Read the pouch's own unit price for the "not $40" comparison. Not
 // mainItems[0]: a free-gift app can drop a $0 line at the top of the cart,
 // which would silently zero the comparison and hide it.
 var pouchLine = mainItems.filter(function (i) { return i.handle === POUCH_HANDLE; })[0];
 var pouchUnit = pouchLine
 ? pouchLine.final_price
 : mainItems.reduce(function (m, i) { return i.final_price > m ? i.final_price : m; }, 0);
 html +=
 '<button type="button" class="gc-sidecart__upgrade" data-sidecart-subscribe>' +
 plusIcon +
 'Add ' + formatMoneyShort(KIT_UPSELL_ADDON_CENTS) + ', get ' + formatMoneyShort(WELCOME_KIT_VALUE_CENTS) + ' in extras' +
 '</button>' +
 '<p class="gc-sidecart__l2" data-sidecart-l2>' +
 'Then a fresh pouch every month, <strong>' + formatMoneyShort(kitRenewal) + '</strong>' +
 (pouchUnit > kitRenewal
 ? '<span class="gc-sidecart__l2-cmp"> not <s>' + formatMoneyShort(pouchUnit) + '</s></span>'
 : '') +
 '</p>' +
 '<p class="gc-sidecart__l2-micro"><strong>Free shipping</strong> · Pause or cancel anytime</p>' +
 '<button type="button" class="gc-sidecart__once" data-sidecart-upgrade>' +
 'Or buy the kit once for ' + formatMoneyShort(kitOnce) + ' + ' + formatMoneyShort(KIT_SHIPPING_CENTS) + ' shipping' +
 '</button>';
 }
 } else {
 html += '<p class="gc-sidecart__bundle-note">Your free welcome gift with a subscription</p>';
 }
 html += '</div>';
 }

 body.innerHTML = html;
 fitUpsellLine();

 // Shared plumbing for both upsell CTAs: disable + label the button, and
 // build the /cart/update.js payload that clears the lines we're replacing.
 // Shipping protection is always kept (it's the shopper's own toggle).
 function bindUpsellCta(btn, busyLabel, run) {
 if (!btn) return;
 btn.addEventListener('click', function () {
 var origLabel = btn.innerHTML;
 btn.disabled = true;
 btn.textContent = busyLabel;
 Promise.resolve()
 .then(run)
 .then(function () { return fetchAndRender(); })
 .catch(function () {
 btn.disabled = false;
 btn.innerHTML = origLabel;
 });
 });
 }
 // Zero out every current line except shipping protection (and, optionally,
 // a variant we're about to keep), so the replacement add lands in a clean cart.
 // Reads the cart at click time so the line keys can't be stale.
 //
 // `knownCart` lets a caller that ALREADY fetched the cart on this same click
 // hand it over instead of paying for a second round trip. Rung 2 does exactly
 // that: its Promise.all fetches /cart.js, and this then fetched it again a few
 // ms later. Measured on the live drawer 2026-08-07, that duplicate cost 261ms
 // and sat on the critical path, delaying the update -> add -> render chain
 // behind it. Only pass a cart fetched in response to THIS click; anything
 // older can carry stale line keys, which is what the re-read was guarding.
 function clearReplacedLines(keepVariantId, knownCart) {
 var cartPromise = knownCart
 ? Promise.resolve(knownCart)
 : fetch('/cart.js').then(function (r) { return r.json(); });
 return cartPromise.then(function (fresh) {
 var updates = {};
 (fresh.items || []).forEach(function (it) {
 if (isShippingProtection(it)) return;
 if (keepVariantId && it.variant_id === keepVariantId) return;
 updates[it.key] = 0;
 });
 if (!Object.keys(updates).length) return null;
 return postCart('/cart/update.js', { updates: updates });
 });
 }

 // Rung 1 - "Upgrade to the full PMS relief kit": swap the one-time pouch
 // for the Girl Chocolate Kit, still a one-time purchase ($127 + $7 shipping),
 // tagged so the drawer shows the "One-time purchase" badge. No welcome-kit
 // gifts, those stay behind the subscription (rung 2).
 bindUpsellCta(body.querySelector('[data-sidecart-upgrade]'), 'Upgrading…', function () {
 return getKitProduct().then(function (kitProduct) {
 var variant = kitProduct && kitProduct.variants && kitProduct.variants[0];
 if (!variant) throw new Error('no kit variant');
 return Promise.all([
 clearReplacedLines(variant.id),
 // One-time Kit, so one pouch. The Kit ships chocolate on this rung
 // too; only the gifts are held back behind the subscription.
 kitPouchFor(variant.id, ONE_TIME_PLAN_LABEL, 1)
 ]).then(function (res) {
 var items = [{
 id: variant.id,
 quantity: 1,
 properties: { _buyonce: 'true', _plan: ONE_TIME_PLAN_LABEL }
 }];
 if (res[1]) items.push(res[1]);
 return postCart('/cart/add.js', { items: items });
 });
 });
 });

 // Rung 2 - "Subscribe and save extra 25% + Free shipping": convert the
 // one-time kit to the Monthly Delivery selling plan and add the 3 welcome
 // gifts; the Welcome Kit auto-discount makes them free and the drawer
 // switches the shipping row from $7 to FREE.
 bindUpsellCta(body.querySelector('[data-sidecart-subscribe]'), 'Subscribing…', function () {
 return Promise.all([
 getKitProduct(),
 ensureWelcomeKitVariants(),
 getSubPouchProduct().catch(function () { return null; }),
 fetch('/cart.js').then(function (r) { return r.json(); })
 ]).then(function (vals) {
 var kitProduct = vals[0];
 var gifts = vals[1];
 var pouchProduct = vals[2];
 var fresh = vals[3];
 var variant = kitProduct && kitProduct.variants && kitProduct.variants[0];
 var plan = kitMonthlyPlan(kitProduct);
 if (!variant || !plan) throw new Error('no kit selling plan');

 // The Kit SHIPS one pouch, so taking the upgrade converts exactly one of
 // the pouches already in the cart into the Kit and keeps the rest. Two
 // pouches in, Kit + one pouch out; a single 2-pack behaves identically
 // because pouchesInLine reads the pack size off the variant title.
 // Before this, the upgrade silently binned every pouch in the cart: a
 // shopper who had chosen two ended up with one, having just paid more.
 var totalPouches = (fresh.items || []).reduce(function (n, it) {
 return n + pouchesInLine(it);
 }, 0);
 var carryOver = Math.max(0, totalPouches - 1);
 var single = subPouchSingle(pouchProduct);

 // The one-time kit line has to go too, a selling plan can't be
 // added to an existing line item.
 // `fresh` is the cart this click already fetched in the Promise.all
 // above, so pass it rather than paying for a second /cart.js.
 return Promise.all([
 clearReplacedLines(null, fresh),
 kitPouchFor(variant.id, plan.name, 1)
 ]).then(function (res) {
 var items = [{
 id: variant.id,
 quantity: 1,
 selling_plan: plan.id,
 properties: { _plan: plan.name }
 }];
 // The Kit's own chocolate, before the gifts: it is the purchase, they
 // are the incentive.
 if (res[1]) items.push(res[1]);
 gifts.forEach(function (g) { items.push(kitContentsLine(g.id, 1)); });
 // Carried-over pouches ride the refill plan, so the whole cart is on
 // subscription. Added as N x the single-pouch variant rather than a
 // pack, so the count is exact whatever the shopper started from.
 if (carryOver > 0 && single) {
 var line = { id: single.id, quantity: carryOver };
 if (single.planId) line.selling_plan = single.planId;
 // Properties have to match what the refill page's own form posts, or
 // Shopify keys this as a DIFFERENT cart line and the same pouch shows
 // up twice. Line identity is variant + selling_plan + properties, and
 // the form path always ends up at these two: every buy box on that page
 // posts _buyonce, and the submit handler then forces _plan to the
 // one-time label. Neither is read back for this line (the drawer labels
 // refill lines off the handle, and isBuyOnceCart defers to the gifts
 // being present), so they exist here purely so the lines merge.
 line.properties = { _buyonce: 'true', _plan: ONE_TIME_PLAN_LABEL };
 items.push(line);
 }
 return postCart('/cart/add.js', { items: items });
 });
 });
 });

 // Bind qty buttons (main items only)
 body.querySelectorAll('.gc-sidecart__item').forEach(function (row) {
 var key = row.getAttribute('data-key');
 row.querySelector('[data-action="minus"]').addEventListener('click', function () {
 var val = parseInt(row.querySelector('.gc-sidecart__qty-val').textContent, 10);
 updateQty(key, Math.max(0, val - 1));
 });
 row.querySelector('[data-action="plus"]').addEventListener('click', function () {
 var val = parseInt(row.querySelector('.gc-sidecart__qty-val').textContent, 10);
 updateQty(key, val + 1);
 });
 row.querySelector('[data-action="remove"]').addEventListener('click', function () {
 updateQty(key, 0);
 });
 });
 }

 // Line two shows the "not $40" comparison only while the whole line still fits
 // on one row. Decided by measuring the rendered text against the drawer's real
 // width rather than by a breakpoint, so it also survives the font fallback
 // before Nunito loads, and any future change to the drawer's width.
 function fitUpsellLine() {
 var line = body.querySelector('[data-sidecart-l2]');
 if (!line || !line.querySelector('.gc-sidecart__l2-cmp')) return;
 line.classList.remove('is-tight');
 if (!line.clientWidth) return; // not laid out yet, try again on open/resize
 if (line.scrollWidth > line.clientWidth) line.classList.add('is-tight');
 }
 // Debounced with a timer, not requestAnimationFrame: rAF is throttled while
 // the tab is not compositing, which would leave the line stale on return.
 var fitTimer = null;
 window.addEventListener('resize', function () {
 clearTimeout(fitTimer);
 fitTimer = setTimeout(fitUpsellLine, 120);
 });
 if (document.fonts && document.fonts.ready) {
 document.fonts.ready.then(fitUpsellLine).catch(function () {});
 }

 function showCartLoading() {
 body.innerHTML = '<div class="gc-sidecart__loading"><span class="gc-sidecart__spinner" aria-hidden="true"></span></div>';
 footerEl.style.display = 'none';
 }

 // fetchAndRender has nine call sites and several of them fire together during
 // one upsell click, so the drawer used to read /cart.js three or four times
 // over. Measured on the live drawer 2026-08-07: two reads started in the SAME
 // millisecond (2004ms +218ms and 2004ms +442ms), then two more at 2738ms and
 // 3039ms, all for one click.
 //
 // Collapsed here rather than at the nine call sites, so a future caller gets
 // the behaviour for free.
 //
 // This is NOT a cache and there is no TTL, because a stale cart in this drawer
 // is a wrong price. While a read is in flight, later callers do not get that
 // read's answer: they set the dirty flag and wait for a FRESH read that starts
 // after they asked. So N concurrent calls collapse to at most 2 sequential
 // reads, and the last render is always from a request issued after the last
 // mutation.
 var cartReadInFlight = null;
 var cartReadDirty = false;
 var cartReadWaiters = [];

 function fetchAndRender() {
 if (cartReadInFlight) {
 cartReadDirty = true;
 return new Promise(function (resolve) { cartReadWaiters.push(resolve); });
 }
 cartReadInFlight = fetch('/cart.js')
 .then(function (r) { return r.json(); })
 .then(renderCart)
 .catch(function () {})
 .then(function () {
 cartReadInFlight = null;
 if (cartReadDirty) {
 cartReadDirty = false;
 var waiters = cartReadWaiters;
 cartReadWaiters = [];
 return fetchAndRender().then(function () {
 waiters.forEach(function (fn) { fn(); });
 });
 }
 var w = cartReadWaiters;
 cartReadWaiters = [];
 w.forEach(function (fn) { fn(); });
 });
 return cartReadInFlight;
 }

 function updateQty(key, qty) {
 fetch('/cart/change.js', {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify({ id: key, quantity: qty })
 }).then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
 }

 // Intercept all /cart/add form submissions
 document.addEventListener('submit', function (e) {
 var form = e.target;
 if (!form || form.action.indexOf('/cart/add') === -1) return;
 e.preventDefault();

 var btn = form.querySelector('[type="submit"], button.gc-cta');
 var origText = btn ? btn.textContent : '';
 if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

 // Detect "buy once" mode, form posts properties[_buyonce]=true.
 // Buy-once adds ONLY the kit + shipping protection. No welcome-kit gifts.
 // The cart drawer renders all 3 gifts as greyed "Not included" upsell
 // rows below the kit, with an Upgrade-to-monthly button.
 var buyonceInput = form.querySelector('input[name="properties[_buyonce]"]');
 var isBuyOnce = !!(buyonceInput && !buyonceInput.disabled && buyonceInput.value === 'true');
 var isSubscription = !isBuyOnce && isChocolatePage();

 // Pick up the chosen plan's display label so the cart drawer can show
 // a "Monthly Delivery" / "3-Month Delivery" / "One-time" tag under the
 // kit's title, even when Appstle selling plans aren't wired yet.
 var planTagInput = form.querySelector('input[name="properties[_plan]"]');
 var planTag = planTagInput ? planTagInput.value : '';
 if (!planTag) {
 var checkedPlan = form.querySelector('input[type="radio"][name="plan_choice"]:checked');
 if (checkedPlan) planTag = checkedPlan.getAttribute('data-title') || '';
 }
 if (isBuyOnce) planTag = ONE_TIME_PLAN_LABEL;

 var idInput = form.querySelector('[name="id"]');
 var sellingPlanInput = form.querySelector('[name="selling_plan"]');
 var qtyInput = form.querySelector('[name="quantity"]');
 var sellingPlanVal = sellingPlanInput && !sellingPlanInput.disabled ? sellingPlanInput.value : '';
 var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
 var items = [];
 if (idInput && idInput.value) {
 var mainItem = { id: idInput.value, quantity: qty, properties: {} };
 if (sellingPlanVal) mainItem.selling_plan = sellingPlanVal;
 if (isBuyOnce) mainItem.properties._buyonce = 'true';
 if (planTag) mainItem.properties._plan = planTag;
 if (Object.keys(mainItem.properties).length === 0) delete mainItem.properties;
 items.push(mainItem);
 }
 if (shippingProtectionVariantId && !shippingProtectionInCart && !shippingProtectionUserRemoved) {
 items.push({ id: shippingProtectionVariantId, quantity: 1 });
 }
 var welcomeKitDeferred = false;
 if (isSubscription) {
 // Subscription mode adds the 3 gifts; the auto-discount marks them free.
 if (welcomeKitVariantIds.length) {
 welcomeKitVariantIds.forEach(function (w) { items.push(kitContentsLine(w.id, 1)); });
 } else {
 welcomeKitDeferred = true; // not loaded yet, add right after
 }
 }
 // Buy-once intentionally adds NOTHING from the welcome kit.
 if (!items.length) { if (btn) { btn.disabled = false; btn.textContent = origText; } return; }

 // Open the drawer instantly with a loading state, instant feedback,
 // and the shopper never sees an empty drawer flash before items appear.
 showCartLoading();
 openDrawer();

 // Every Kit form goes through here, so the chocolate is attached in ONE
 // place rather than in each buy box. Gated on the variant id rather than
 // the URL because the Kit is also sold from the mini CTAs and the final
 // CTA, and one of those living on a non-Kit page would silently ship
 // without chocolate again.
 kitPouchFor(idInput && idInput.value, planTag, qty)
 .then(function (pouchLine) {
 if (pouchLine) items.push(pouchLine);
 return fetch('/cart/add.js', {
 method: 'POST',
 headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
 body: JSON.stringify({ items: items })
 });
 })
 .then(function (r) {
 if (!r.ok) throw new Error('Cart error');
 return r.json();
 })
 .then(function () {
 if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.disabled = false; btn.textContent = origText; }, 1500); }
 openDrawer();
 if (welcomeKitDeferred) return addWelcomeKit().then(fetchAndRender);
 return fetchAndRender();
 })
 .catch(function () {
 if (btn) { btn.disabled = false; btn.textContent = origText; }
 // Do NOT fall back to a native form submit - that navigates to /cart.
 // Keep the shopper on-page; show whatever is currently in the cart drawer.
 fetchAndRender();
 });
 }, true);

 // Handle <a> tags that should add to cart
 document.querySelectorAll('a[data-gc-action="add-to-cart"]').forEach(function (link) {
 link.addEventListener('click', function (e) {
 if (!link.closest('form')) {
 e.preventDefault();
 // The subscription PDP's buy box is [data-gc-pouchsub-form]: its hidden id
 // and selling_plan inputs track whichever plan the shopper selected at the
 // top of the page. Other templates use #vhero-cart-form. Submitting
 // whichever exists makes a secondary CTA add the SELECTED plan through the
 // same AJAX path and the same cart pop-up, instead of navigating away.
 var heroForm = document.querySelector('#vhero-cart-form') || document.querySelector('[data-gc-pouchsub-form]');
 if (heroForm) {
 var formEvt = new Event('submit', { bubbles: true, cancelable: true });
 heroForm.dispatchEvent(formEvt);
 } else {
 window.location.href = link.href;
 }
 }
 });
 });

 // "Buy once", handled by the dedicated buy-once form's submit event
 // (form posts properties[_buyonce]=true). Legacy <a> handler kept as a
 // no-op safety net: if there's an anchor with that action we now route
 // it through the buyonce form so the cart logic is consistent.
 document.querySelectorAll('a[data-gc-action="add-to-cart-once"]').forEach(function (link) {
 link.addEventListener('click', function (e) {
 var buyForm = document.querySelector('#vhero-buyonce-form');
 if (buyForm) {
 e.preventDefault();
 buyForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
 }
 });
 });

 // Sticky CTA uses AJAX too
 var stickyBtn = document.querySelector('[data-gc-stickycta-btn]');
 if (stickyBtn) {
 stickyBtn.addEventListener('click', function (e) {
 // On the kit product page: add to cart via the buy-box form.
 // Anywhere else (e.g. home): do nothing here so initStickyCta's
 // handler runs and navigates to the kit product page ("Shop Now").
 var heroForm = document.querySelector('#vhero-cart-form');
 if (heroForm) {
 e.stopImmediatePropagation();
 heroForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
 }
 });
 }

 // Cart icon in header opens side cart (exclude "View full cart" link inside drawer)
 var cartLinks = document.querySelectorAll('a[href="/cart"], [data-gc-cart-link]');
 cartLinks.forEach(function (link) {
 if (link.classList.contains('gc-sidecart__viewcart')) return; // skip, this link should navigate normally
 link.addEventListener('click', function (e) {
 e.preventDefault();
 fetchAndRender();
 openDrawer();
 });
 });

 fetchAndRender();
 }

 /* ============================================================
 Lazy videos - hydrate <video data-lazy-src> only when the element
 nears the viewport, so autoplay UGC clips (several MB each) stay
 out of the initial page load. data-lazy-autoplay also starts
 playback on hydrate; other players (e.g. vr21 deck) call play()
 themselves and hydrate in their own play path as a fallback.
 ============================================================ */
 function initLazyVideos() {
 var vids = document.querySelectorAll('video[data-lazy-src]');
 if (!vids.length) return;
 function hydrate(v) {
 if (!v.getAttribute('src') && v.dataset.lazySrc) {
 v.src = v.dataset.lazySrc;
 }
 /* Only force load/playback for autoplay videos; other players
 (e.g. the UGC deck) fetch on their own play() call, so a bare
 src assignment with preload="none" costs no bandwidth. */
 if (v.hasAttribute('data-lazy-autoplay')) {
 v.load();
 var p = v.play();
 if (p && p.catch) p.catch(function () {});
 }
 }
 if (!('IntersectionObserver' in window)) {
 vids.forEach(hydrate);
 return;
 }
 var io = new IntersectionObserver(function (entries) {
 entries.forEach(function (en) {
 if (!en.isIntersecting) return;
 io.unobserve(en.target);
 hydrate(en.target);
 });
 }, { rootMargin: '600px 0px' });
 vids.forEach(function (v) { io.observe(v); });
 }

 /* ============================================================
 Init on DOM ready
 ============================================================ */
 function ready(fn) {
 if (document.readyState !== 'loading') fn();
 else document.addEventListener('DOMContentLoaded', fn);
 }

 ready(function () {
 const header = document.querySelector('[data-gc-header]');
 if (header) initAnnouncement(header);
 initMenu();
 initStickyCta();
 initTabs();
 initFAQ();
 initReviews();
 initBuyBox();
 initGiftsModal();
 initSupplementFacts();
 initProductCard();
 initVideoCarousel();
 initScienceAccordion();
 initChatAnimation();
 initAjaxCart();
 initLazyVideos();
 // The drawer owns /cart/add from here. Tells the capture-phase hold in
 // layout/theme.liquid to stand down and replay whatever the shopper clicked
 // while this deferred file was still loading. Without it, an early click
 // posts natively and Shopify redirects to /cart.
 window.__gcCartReady = true;
 if (window.__gcReleaseHeldAdd) window.__gcReleaseHeldAdd();
 });
})();
/* push timestamp: Sun May 24 19:14:45 EDT 2026 */
